module.exports = __webpack_public_path__ + "img/LBA-DEV.63c3ca9e.svg";